import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'AfriCycle Zambia | EPR Compliance for Plastic Packaging & WEEE',
  description = 'AfriCycle Zambia is your trusted partner for Extended Producer Responsibility (EPR) compliance. Plastic packaging and WEEE recycling solutions in Zambia.',
  keywords = 'AfriCycle Zambia, AfriCycle PRO, EPR compliance Zambia, plastic packaging recycling, WEEE recycling Zambia',
  canonicalUrl = 'https://africycle.pro',
  ogImage = 'https://africycle.pro/africycle-logo-new.png',
  ogType = 'website',
  noindex = false
}) => {
  const fullTitle = title.includes('AfriCycle') ? title : `${title} | AfriCycle Zambia`;
  
  // Build meta tags array for Helmet prop API (avoids React 19 + helmet children incompatibility)
  const metaTags = [
    { name: 'title', content: fullTitle },
    { name: 'description', content: description },
    { name: 'keywords', content: keywords },
    // Open Graph
    { property: 'og:type', content: ogType },
    { property: 'og:url', content: canonicalUrl },
    { property: 'og:title', content: fullTitle },
    { property: 'og:description', content: description },
    { property: 'og:image', content: ogImage },
    { property: 'og:site_name', content: 'AfriCycle Zambia' },
    // Twitter
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:url', content: canonicalUrl },
    { name: 'twitter:title', content: fullTitle },
    { name: 'twitter:description', content: description },
    { name: 'twitter:image', content: ogImage }
  ];
  
  // Add noindex if specified
  if (noindex) {
    metaTags.push({ name: 'robots', content: 'noindex, nofollow' });
  }
  
  const linkTags = [
    { rel: 'canonical', href: canonicalUrl }
  ];
  
  return (
    <Helmet
      title={fullTitle}
      meta={metaTags}
      link={linkTags}
    />
  );
};

export default SEO;
